// extracted by mini-css-extract-plugin
export default {"container":"container-d27dgBi5","title":"title-Rt1hWp2X","timer":"timer-QDpZ276p","buttons":"buttons-ANyKkTUF","resumeButton":"resumeButton-PNXln0S8"};